<template>
  <v-card flat>
    <v-card-text>

      <!-- <caminhao-caixas-distribuir /> -->
      

      <btn-selec-pedidos-liberados />
      <v-row>
        <v-col xl="4" lg="4" md="4" cols="12">
          <pedidos-adicionados-form-carga
            v-for="(ped, i) in pedidosAdicionados"
            :key="i"
            :pedido="ped"
          />
        </v-col>

        <v-col xl="8" lg="8" md="8" cols="12">
          <v-card flat class="grey lighten-4 mt-2" rounded="lg">
            <v-card-title class="font-weight-bold subtitle-2"
              >Distribuir pedidos</v-card-title
            >
            <v-card-text>
              <caminhao-caixas-distribuir />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
//import CaminhaoCaixasDistribuir from "./CaminhaoCaixasDistribuir.vue";
import BtnSelecPedidosLiberados from "./BtnSelecPedidosLiberados.vue";
import PedidosAdicionadosFormCarga from "./PedidosAdicionadosFormCarga.vue";
export default {  
  components: { /*CaminhaoCaixasDistribuir,*/ BtnSelecPedidosLiberados, PedidosAdicionadosFormCarga },
  computed: {
    ...mapState("formacaoCarga", ["pedidosAdicionados"]),
  },
};
</script>

<style>
</style>